module.exports = __webpack_public_path__ + "img/Future-Education.6387c855.svg";